import React, { useState } from 'react'
import * as Yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import clsx from "clsx"
import apiService from "../../../../services/api.service"

const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
        .email('Invalid email format')
        .required('Email is required'),
})

const initialForgotPasswordValues = {
    email: '',
}

const ForgotPassword = ({close}) => {
    const [loading, setLoading] = useState(false)

    const {register, handleSubmit, formState: {isValid}, reset}
        = useForm({
        initialValues: initialForgotPasswordValues,
        validationSchema: forgotPasswordSchema,
        resolver: yupResolver(forgotPasswordSchema),
    })

    const onSubmit = async (data) => {
        setLoading(true)

        try {
            const response = await apiService.forgotPassword(data.email)
            if (response && response.status === 200) {
                close()
                reset()
            }
        } catch (error) {
            console.error('API error:', error)
        } finally {
            setLoading(false)
        }
    }

    const handleClose = () => {
        close()
        reset()
    }

    return (
        <div className="PopupModalOverlay" onClick={close}>
            <div className="PopupModal w-[480px]"
                 onClick={(e) => e.stopPropagation()}>
                <div className={ "SelectPopupHeader" }>
                    <div className={ "flex flex-col gap-[6px]" }>
                        <div className={ "PopupTitle" }>Forgot Password</div>
                        <div className={ "PopupDescription" }>
                            For the email address where the password reset link will be sent.
                        </div>
                    </div>
                    <button onClick={ handleClose }>
                        <img alt={ "Logo" } src={ "/media/icons/close-dark.svg" } className={ "w-5 h-5" }/>
                    </button>
                </div>
                <form onSubmit={ handleSubmit(onSubmit) } className={ "w-full" }>
                    <div className="PopupBody flex flex-col gap-4 py-6">
                        <div className="w-full flex flex-col gap-[6px]">
                            <div className={ "XSmallMediumText" }>Email</div>
                            <input
                                className="TextInput w-full placeholder-gray-400"
                                { ...register("email") }
                                placeholder="Enter"
                                type="email"
                            />
                        </div>
                    </div>
                    <div className="PopupFooter">
                        <div className={ "flex gap-3 items-end" }>
                            <button
                                type="button"
                                className={ clsx("SecondaryButton", "w-[110px]") }
                                onClick={ handleClose }
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={ !isValid || loading }
                                className={ clsx("PrimaryButton", "w-[110px]", (!isValid || loading) && "opacity-50 cursor-not-allowed") }
                            >
                                { loading ? 'Sending...' : 'Submit' }
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ForgotPassword
